<template>
    <div>
        <!-- <h1 class="display-heading">{{title}}<i v-if="isFamily" class="ml-2 fas fa-question-circle fa-xl" data-toggle="tooltip" :title="getTitleLabel()"></i></h1> -->
        <h1 class="display-heading">{{title}}</h1>

        <router-link :to="{'name': uploadPath}" class="btn btn-primary btn-primary-insv mb-3">
            Upload Doctor's Prescription
        </router-link>

        <div class="d-flex align-items-baseline">
            <div v-if="isFamily" class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Patient Name:</label>
                <input style="width: 150px" type="text" name="filterName" data-vv-as="filter patient name" data-vv-validate-on="blur"
                    v-model="filter.name" v-validate="''"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Created Date:</label>
                <input style="width: 150px" ref="filterDate" type="text" name="filterDate" data-vv-as="filter created date" data-vv-validate-on="blur"
                    v-model="filter.date" v-validate="'date_format:DD/MM/YYYY'"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterDate')
                    }" >
                <div v-show="validationErrors.has('filterDate')" class="invalid-feedback">
                    {{ validationErrors.first('filterDate') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Status:</label>
                <select name="filterStatus" data-vv-validate-on="blur" data-vv-as="filter status"
                    v-validate="''" v-model="filter.status" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('filterIdentityType')
                }">
                    <option value="-1">Please Select</option>
                    <option value="0">New</option>
                    <option value="1">Awaiting Pharmacy Review</option>
                    <option value="2">Confirmed</option>
                    <option value="3">In Preparation</option>
                    <option value="4">Delivered</option>
                    <option value="99">Cancelled</option>
                    <option value="100">Received</option>
                    <option value="998">Payment Required</option>
                    <option value="999">No Payment Received</option>
                    <option value="1000">Payment Success</option>
                </select>
                <div v-show="validationErrors.has('filterStatus')" class="invalid-feedback">
                    {{ validationErrors.first('filterStatus') }}
                </div>
            </div>
            <button @click="getPrescriptions" class="btn btn-primary">Search</button>
        </div>

        <div class="d-md-none">
            <div class="card mb-3" v-if="prescriptionList.length === 0">
                <div class="card-body">
                    {{isTableLoading ? "Loading Data": "No Data"}}
                </div>
            </div>
            <div class="card mb-3" v-for="(prescription, index) in prescriptionList" :key="index">
                <div class="card-body">
                    <div v-if="isFamily" class="mb-3">
                        <label class="label-display">
                            Patient Name
                        </label>
                        <div>
                            {{prescription.patientName}}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Created Date
                        </label>
                        <div>
                            {{prescription.createDate}}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Prescription Id
                        </label>
                        <div>
                            {{prescription.shortId}}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Description
                        </label>
                        <div>
                            <template v-if="prescription.isUploadedPrescription">Uploaded Prescription List</template>
                            <template v-else-if="prescription.isClinicPrescription">Clinic Medicine Purchase</template>
                            <template v-else>
                                Consultation with Doctor
                            </template>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Status
                        </label>
                        <div>
                            <prescription-status :statusId="prescription.statusId"></prescription-status>
                        </div>
                    </div>
                    <div>
                        <label class="label-display">
                            Action
                        </label>
                        <div>
                            <user-prescription-action :classList="['btn', 'btn-primary', 'btn-primary-insv']" :statusId="prescription.statusId" :prescriptionId="prescription.prescriptionListId" :detailPath="detailPath"></user-prescription-action>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-none d-md-block">
            <div ref="tableSection">
                <div class="table-responsive">
                    <table ref="listTable" class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col" v-if="isFamily">Patient Name</th>
                                <th scope="col">Created Date</th>
                                <th scope="col">Prescription Id</th>
                                <th scope="col">Description</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-show="prescriptionList.length === 0">
                                <td :colspan="columnsCount" class="text-center font-italic">
                                    {{isTableLoading ? "Loading Data": "No Data"}}
                                </td>
                            </tr>

                            <tr v-for="(prescription, index) in prescriptionList" :key="index">
                                <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                                <td class="text-nowrap" v-if="isFamily">{{prescription.patientName}}</td>
                                <td>
                                    {{prescription.createDate}}
                                </td>
                                <td>
                                    {{prescription.shortId}}
                                </td>
                                <td>
                                    <template v-if="prescription.isUploadedPrescription">Uploaded Prescription List</template>
                                    <template v-else-if="prescription.isClinicPrescription">Clinic Medicine Purchase</template>
                                    <template v-else>
                                        Consultation with Doctor
                                    </template>
                                </td>
                                <td>
                                    <prescription-status :statusId="prescription.statusId"></prescription-status>
                                </td>
                                <td>
                                    <user-prescription-action :statusId="prescription.statusId" :prescriptionId="prescription.prescriptionListId" :detailPath="detailPath"></user-prescription-action>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <pagination v-model="pagination.currentPage"
                        :totalPages="pagination.totalPages"
                        :scrollPosition="pagination.scrollPosition">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
import pagination from '@/components/pagination';
import prescriptionStatus from '@/components/prescription-status';
import userPrescriptionAction from '@/components/prescription-action/user';
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
export default {
    'name': 'PrescriptionList',
    'components': {
        prescriptionStatus,
        userPrescriptionAction,
        pagination
    },
    data () {
        return {
            'prescriptionList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'filter': {
                'name': null,
                'date': null,
                'status': -1
            }
        };
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        isFamily () {
            return this.$route.name === 'family-prescription-list';
        },
        title () {
            if (this.isFamily) {
                return 'Family Prescriptions';
            }
            return 'My Prescriptions';
        },
        getApi () {
            if (this.isFamily) {
                return 'Prescription/GetFamily';
            }
            return 'Prescription/GetAll';
        },
        uploadPath () {
            if (this.isFamily) {
                return 'family-upload-prescription';
            }
            return 'user-upload-prescription';
        },
        detailPath () {
            if (this.isFamily) {
                return 'family-prescription-detail';
            }
            return 'user-prescription-detail';
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getPrescriptions();
            });
        }
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPrescriptions();
        this.initializeDatePickers();
    },
    'methods': {
        getPrescriptions () {
            this.axios.post(this.getApi, {
                'd': convertDateToIso8601(this.filter.date),
                'pn': this.filter.name,
                's': this.filter.status,
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;
                this.prescriptionList = list.map((prescription) => ({
                    'prescriptionListId': prescription.pli,
                    'shortId': prescription.plis,
                    'createDate': convertDateToDDMMYYYY(prescription.cd),
                    'status': prescription.s,
                    'statusId': prescription.ps,
                    'consultationId': prescription.cid,
                    'isUploadedPrescription': prescription.iu,
                    'isClinicPrescription': prescription.icp,
                    'patientName': prescription.pn
                }));
            }).catch(({
                response
            }) => {

            });
        },
        initializeDatePickers () {
            $(this.$refs.filterDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.filterDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.filter.date = picker.startDate.format('DD/MM/YYYY');
                }
            );
        },
        getTitleLabel () {
            return 'Only can view child(ren) aged below 18.\n' +
            'Upon child(ren) attaining age 18 or above, they need to register another personal account with own user ID for migrating their previous medical records.';
        }
    }
};

</script>

<style>

</style>
